import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cm73zmtk8g: FaireBrandEntity = {
  token: "b_cm73zmtk8g",
  type: "brand",
  name: "Sage & Stone Apothecary",
  avatarUrl:
    "https://cdn.faire.com/fastly/bb47a3ba39c4acdae519032ea83c52973709a2158725c2df8fe43388e8e7cce1.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/bbd56362be1b6ca45a871a777197873eef2bc97c5ab0a50b832ad9893c4ebd24.png",
  logoUrl:
    "https://cdn.faire.com/fastly/bb47a3ba39c4acdae519032ea83c52973709a2158725c2df8fe43388e8e7cce1.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bbd56362be1b6ca45a871a777197873eef2bc97c5ab0a50b832ad9893c4ebd24.png",
  location: "Remington, VA, USA",
  minimumOrderDollars: 137,
  rating: 5,
  reviewCount: 246,
  isTopShop: true,
  isInsider: true,
  description:
    "Sage and Stone Apothecary is nestled in the heart of Remington, Virginia. This haven was born from a vision to intertwine the purity of nature with the art of healing, creating a space where tranquility meets vitality.\n\nThe story of Sage and Stone Apothecary began with a simple, yet profound belief: that every individual has an innate ability to harmonize with the earth's rhythms. With this philosophy, the apothecary set out to meticulously craft all-organic, small-batch skincare and herbal tea blends that not only soothe the body but also nurture the soul.\n\nAt the core of Sage and Stone Apothecary’s mission lies a deep commitment to inner serenity and environmental sustainability. Each product is a testament to the apothecary’s dedication to empowering individuals to discover their natural radiance and foster a connection with the world around them.\n\nThe apothecary’s doors are open wide, inviting all who seek to replenish their spirit and embrace a life of holistic well-being. The founders believe that through the alchemy of earth’s gifts, one can find a path to wellness that resonates with both the ancient wisdom of the past and the innovative spirit of the future.\n\nSage and Stone Apothecary is not just a brand; it’s a journey towards a more balanced and radiant life, where every blend is a brushstroke on the canvas of self-care. It’s a story of passion, purity, and the power of nature’s bounty, waiting to be discovered.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:30.137Z",
    importedBy: "entity-db-cli",
  },
};
